import classNames from 'classnames';

import { useFeature } from '@features/FeatureToggle';

import type { TpCardPlanChildrenProps } from '@features/Paywall/widgets/subscription-card/types';
import styles from './price-unit-full.module.scss';
import { currencyReplacer } from '@utils/payment/currency-replacer';

const formatPrice = (price: number) => {
  return price.toFixed(2);
};

export const PriceUnitFull = (props: TpCardPlanChildrenProps) => {
  const { plan, checked, reverse, className, currencyAsSymbol } = props;
  const isIntroOfferEnabled = useFeature('introOffer');

  if (!plan) {
    return null;
  }

  const {
    initialPrice,
    fullPrice,
    trialPeriodDays,
    fractionalPrice,
    currency,
    introOfferData,
  } = plan;

  const currencyTransformed = currencyAsSymbol
    ? currencyReplacer(currency)
    : `${currency} `;

  let priceUnitFull: string;
  if (initialPrice != null && trialPeriodDays) {
    priceUnitFull = `${currency} ${(fullPrice / trialPeriodDays).toFixed(2)}`;
  } else {
    priceUnitFull = isIntroOfferEnabled
      ? `${currencyTransformed}${formatPrice(introOfferData?.fractionalPrice as number)}`
      : `${currencyTransformed}${formatPrice(fractionalPrice)}`;
  }

  const priceUnitFullReversed =
    initialPrice != null && trialPeriodDays
      ? `${(fullPrice / trialPeriodDays).toFixed(2)}${currencyTransformed}`
      : `${formatPrice(fractionalPrice)}${currencyTransformed}`;

  return (
    <del
      className={classNames(
        styles.priceUnitFull,
        {
          [styles.priceUnitFullChecked]: checked,
        },
        className,
      )}
    >
      {reverse ? priceUnitFullReversed : priceUnitFull}
    </del>
  );
};
